export enum UserDashboardType {
  PowerBi = 'PowerBi',
  Tableau = 'Tableau',
}
